import { collectionEngineV1 } from '../apis.js';
const req = collectionEngineV1('/street-view');
export const getImage = (address) => {
    const params = new URLSearchParams({
        address: address.address,
        zipcode: `${address.zipcode}`,
        city: address.city,
    });
    return req('GET', `/?${params.toString()}`);
};
//# sourceMappingURL=street-view.js.map